import PropTypes from "prop-types";

export const NewsModel = ({ id, imageUrl, type, title, description }) => {
  return {
    id,
    imageUrl,
    type,
    title,
    description,

    // Convert to Firestore map (equivalent to Flutter's toMap())
    toMap: () => {
      return {
        id: id,
        imageUrl: imageUrl,
        type: type,
        title: title,
        description: description,
      };
    },
  };
};

// Factory function equivalent to Flutter's fromDoc()
NewsModel.fromDoc = (doc) => {
  const data = doc.data();
  return NewsModel({
    id: data?.id || doc.id,
    imageUrl: data?.imageUrl || "",
    type: data?.type || "",
    title: data?.title || "",
    description: data?.description || "",
  });
};

// PropTypes for validation
NewsModel.propTypes = {
  id: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
};

export default NewsModel;
